import React from 'react';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import WebPlayer from '../webPlayerGbf/WebPlayer';
import Typography from '@material-ui/core/Typography';

const TEST_SESSION_LPS = '63051';
const TEST_TEMPLATE_LPS = '1783';
const TEST_TEAM_LPS = '628';

const TEST_SESSION_GPS = '62973';
const TEST_TEMPLATE_GPS = '1715';
const TEST_TEAM_GPS = '605';

const TestGbfLoader = () => {

  return (
    <div>
      <div style={{maxWidth: '1600px'}}>

        <Paper>
          <Box p={2} mb={3}>
            <Typography variant="h5" gutterBottom>LPS</Typography>
            <WebPlayer currentDrill={null} sessionId={TEST_SESSION_LPS} teamId={TEST_TEAM_LPS} templateId={TEST_TEMPLATE_LPS} />
          </Box>
        </Paper>

        <Paper>
          <Box p={2} mb={3}>
            <Typography variant="h5" gutterBottom>GPS</Typography>
            <WebPlayer currentDrill={null} sessionId={TEST_SESSION_GPS} teamId={TEST_TEAM_GPS} templateId={TEST_TEMPLATE_GPS} />
          </Box>
        </Paper>

      </div>
    </div>
  )
}

export default TestGbfLoader;
